export const planData = [
  {
    title: "BASIC PLAN",
    price: "$25",
    feature: [
      "2 hours of excercises",
      "Free consultaion of coaches",
      "Access to The Community",
    ],
  },
  {
    title: "PREMIUM PLAN",
    price: "$30",
    feature: [
      "5 hours of excercises",
      "Free consultaion of coaches",
      "Access to minibar",
    ],
  },
  {
    title: "PRO PLAN",
    price: "$45",
    feature: [
      "8 hours of excercises",
      "Consultation of Private Coach",
      "Free Fitness Merchandises",
    ],
  },
];
